import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2C2520] text-[#F2EBE1] mt-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-display text-4xl leading-none mb-4">
              Ишеевские
              <br />
              <span className="text-[#C65D3B]">ПИРОГИ & ПИРОЖКИ</span>
            </div>
            <p className="text-sm text-[#C9BFB1] max-w-sm leading-relaxed">
              Это домашняя пекарня, где ежедневно для Вас готовится:<br></br>
· печёная и жареная выпечка: с капустой, луком и яйцом, картошкой, мясом, рыбой, курагой и яблоками<br></br>
· открытые ватрушки с изюмом и закрытые с ананасом, киви, вишней, малиной, лимоном<br></br>
· фаст-фуд<br></br>
· свадебные караваи<br></br>
· постные пироги и пирожки<br></br>

На заказ по традиционным рецептам с доставкой по г. Ульяновску и области.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="label-eyebrow text-[#C65D3B] mb-4">Навигация</div>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#C65D3B] transition-colors">
                  Каталог
                </Link>
              </li>
              <li>
                <Link to="/dostavka-pirogov-ulyanovsk/" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#C65D3B] transition-colors">
                  Доставка
                </Link>
              </li>
              <li>
                <Link to="/pirogi-na-zakaz/" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#C65D3B] transition-colors">
                  Пироги на заказ
                </Link>
              </li>
              <li>
                <Link to="/o-kompanii/" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#C65D3B] transition-colors">
                  О нас
                </Link>
              </li>
              <li>
                <Link to="/blog" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#C65D3B] transition-colors">
                  Блог
                </Link>
              </li>
              <li>
                <Link to="/kontakty/" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#C65D3B] transition-colors">
                  Контакты
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="label-eyebrow text-[#C65D3B] mb-4">Контакты</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-[#C65D3B]" />
                <a href="tel:+79378764537" className="hover:text-[#C65D3B]">
                  +7 937 876 45 37
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#C65D3B]" />
                <span>Ульяновск и область — доставка</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="mt-0.5 text-[#C65D3B]" />
                <span>Без выходных · приём заказов с 9:00 до 21:00</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://vk.com/pirogi_pirogki_73"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-[#5C4F45] hover:border-[#C65D3B] flex items-center justify-center transition-colors text-xs font-bold"
                data-testid="footer-vk"
              >
                ВК
              </a>
              <a
                href="https://ok.ru/profile/578918939574"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-[#5C4F45] hover:border-[#C65D3B] flex items-center justify-center transition-colors text-xs font-bold"
                data-testid="footer-ok"
              >
                OK
              </a>
              <a
                href="https://www.instagram.com/pirogi_torty_73"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-[#5C4F45] hover:border-[#C65D3B] flex items-center justify-center transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#5C4F45] mt-14 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[#9D9285]">
          <div>© {new Date().getFullYear()} Ишеевские пироги · Ульяновск</div>
          <Link
            to="/admin/login"
            className="hover:text-[#C65D3B] transition-colors"
            data-testid="footer-admin-link"
          >
            Админ-панель
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
